import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=3cb8823a&scoped=true"
import script from "./Safety.vue?vue&type=script&lang=js"
export * from "./Safety.vue?vue&type=script&lang=js"
import style0 from "./Safety.vue?vue&type=style&index=0&id=3cb8823a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8823a",
  null
  
)

export default component.exports